const fmt = (val) => (val % 1 === 0 ? val.toString() : val.toFixed(1));

const FormatNumberCounter = (num) => {
  const absNum = Math.abs(num);

  if (absNum >= 1e9) return fmt(num / 1e9) + "B";
  if (absNum >= 1e6) return fmt(num / 1e6) + "M";
  if (absNum >= 1e3) return fmt(num / 1e3) + "K";

  console.log("Number is less than 1000, returning as is:", num);

  return num + ""; // Convert to string

  // return num.toString();
};

export default FormatNumberCounter;
